module.exports = __webpack_public_path__ + "static/duclair-85c9b868f1415e4641f99cb292151d1a.jpg";